import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import React, { BaseSyntheticEvent } from "react";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { Content } from "@iventis/translations/content/typed-content";
import { OperatorsTranslatedTextMapping } from "../types/data-table.types";

// Using old function syntax so we can pass JSX generics
export function OperatorSelectorComponent<T extends string = string>({
    operator,
    setOperator,
    operators,
}: React.PropsWithChildren<{
    operator: T;
    setOperator: (operator: T) => void;
    operators: OperatorsTranslatedTextMapping<T>;
}>) {
    const translate = useIventisTranslate();
    return (
        <FormControl component="fieldset">
            <FormLabel component="legend">{translate(Content.map12.data_table_filter.operator)}</FormLabel>
            <RadioGroup aria-label="Operator" name="operator" value={operator} onChange={(e: BaseSyntheticEvent) => setOperator(e.target.value)}>
                {Object.keys(operators).map((op) => (
                    <FormControlLabel key={op.toString()} value={op} control={<Radio color="primary" size="small" />} label={operators[op]} />
                ))}
            </RadioGroup>
        </FormControl>
    );
}
